import { api } from '../axios'
import type { ApiResponse } from '../../../types'

// Combined Locations API that includes both RD Blocks and Habitations
// This maintains backward compatibility with the original locationsApi
export const locationsApi = {
  // Districts
  getDistricts: () =>
    api.get<ApiResponse<{id: number, name: string}[]>>('/locations/districts'),
  
  // RD Blocks
  getRdBlocks: (districtId?: number) =>
    api.get<ApiResponse<{id: number, name: string, district_id: number}[]>>(
      districtId ? `/locations/rd-blocks/${districtId}` : '/locations/rd-blocks'
    ),

  getAllRdBlocks: () =>
    api.get<ApiResponse<{id: number, name: string, district_id: number, is_active: boolean}[]>>('/locations/rd-blocks/all'),

  getActiveRdBlocks: () =>
    api.get<ApiResponse<{id: number, name: string, district_id: number, is_active: boolean}[]>>('/locations/rd-blocks/active'),

  createRdBlock: (data: { name: string, district_id: number, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/locations/rd-blocks', data),

  updateRdBlock: (id: number, data: { name: string, district_id: number, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/locations/rd-blocks/${id}`, data),

  deleteRdBlock: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/rd-blocks/${id}`),

  hardDeleteRdBlock: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/rd-blocks/${id}/permanent`),

  // Habitations (Villages)
  getVillages: (rdBlockId?: number) =>
    api.get<ApiResponse<{id: number, name: string, rd_block_id: number}[]>>(
      rdBlockId ? `/locations/villages/${rdBlockId}` : '/locations/villages'
    ),

  getAllVillages: () =>
    api.get<ApiResponse<{id: number, name: string, rd_block_id: number, is_active: boolean}[]>>('/locations/villages/all'),

  getActiveVillages: () =>
    api.get<ApiResponse<{id: number, name: string, rd_block_id: number, is_active: boolean}[]>>('/locations/villages/active'),

  createHabitation: (data: { name: string, rd_block_id: number, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/locations/habitations', data),

  updateHabitation: (id: number, data: { name: string, rd_block_id: number, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/locations/habitations/${id}`, data),

  deleteHabitation: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/habitations/${id}`),

  hardDeleteHabitation: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/habitations/${id}/permanent`),
}

